<template>
  <div class="sidebar-wrapper">
    <!-- 1. 工作台入口 (主菜单模式下显示) -->
    <div v-if="!isWebsiteContext && !isMiniProgramContext" class="workbench-trigger" @click="$router.push('/admin/workbench')" :class="{ 'is-active': $route.path === '/admin/workbench' || $route.path === '/admin/' }">
      <div class="trigger-box">
        <el-icon><HomeFilled /></el-icon>
        <span class="text">工作台</span>
      </div>
    </div>

    <!-- 2. 返回主菜单 (处于任一子模块内时显示) -->
    <div v-else class="workbench-trigger" @click="$router.push('/admin/workbench')">
      <div class="trigger-box back-mode">
        <el-icon><ArrowLeftBold /></el-icon>
        <span class="text">返回主菜单</span>
      </div>
    </div>

    <!-- 模块上下文标签 (与按钮文字同字号颜色但变淡) -->
    <div v-if="isWebsiteContext" class="module-context-tag">网站管理</div>
    <div v-else-if="isMiniProgramContext" class="module-context-tag">小程序管理</div>

    <el-menu
      :default-active="activeMenu"
      router
      class="custom-menu"
    >
      <!-- A. 网站管理子菜单 (精简模式) -->
      <template v-if="isWebsiteContext">
        <el-menu-item index="/admin/website/home" class="menu-item">
          <el-icon><House /></el-icon>
          <template #title>首页设置</template>
        </el-menu-item>
        <el-menu-item index="/admin/website/about" class="menu-item">
          <el-icon><Collection /></el-icon>
          <template #title>协会概况</template>
        </el-menu-item>
        <el-menu-item index="/admin/website/news" class="menu-item">
          <el-icon><Postcard /></el-icon>
          <template #title>新闻中心</template>
        </el-menu-item>
        <el-menu-item index="/admin/website/policy" class="menu-item">
          <el-icon><InfoFilled /></el-icon>
          <template #title>政策法规</template>
        </el-menu-item>
        <el-menu-item index="/admin/website/contact" class="menu-item">
          <el-icon><ChatLineRound /></el-icon>
          <template #title>留言管理</template>
        </el-menu-item>
        <el-menu-item index="/admin/website/member-apply" class="menu-item">
          <el-icon><DocumentChecked /></el-icon>
          <template #title>入会申请</template>
        </el-menu-item>
        <el-menu-item index="/admin/website/mediation-apply" class="menu-item">
          <el-icon><Service /></el-icon>
          <template #title>调解申请</template>
        </el-menu-item>
        <el-menu-item index="/admin/website/legal-aid" class="menu-item">
          <el-icon><FirstAidKit /></el-icon>
          <template #title>法律援助</template>
        </el-menu-item>
      </template>

      <!-- B. 小程序管理子菜单 (仅在小程序上下文时显示) -->
      <template v-else-if="isMiniProgramContext && isAdmin">
        <el-menu-item index="/admin/home" class="menu-item">
          <el-icon><Monitor /></el-icon>
          <template #title>管理首页</template>
        </el-menu-item>
        <el-menu-item index="/admin/company" class="menu-item">
          <el-icon><OfficeBuilding /></el-icon>
          <template #title>会员单位</template>
        </el-menu-item>
        <el-menu-item index="/admin/worker" class="menu-item">
          <el-icon><User /></el-icon>
          <template #title>注册用户</template>
        </el-menu-item>
        <el-menu-item index="/admin/account" class="menu-item">
          <el-icon><Setting /></el-icon>
          <template #title>会员账号</template>
        </el-menu-item>
      </template>

      <!-- C. 租户菜单 (仅在非管理员且无特殊上下文时展示) -->
      <template v-else-if="!isAdmin">
        <el-menu-item index="/user/home" class="menu-item">
          <el-icon><Monitor /></el-icon>
          <template #title>首页</template>
        </el-menu-item>
        <el-menu-item index="/user/recruitment" class="menu-item">
          <el-icon><Suitcase /></el-icon>
          <template #title>招聘管理</template>
        </el-menu-item>
        <el-menu-item index="/user/employee" class="menu-item">
          <el-icon><User /></el-icon>
          <template #title>员工管理</template>
        </el-menu-item>
        <el-menu-item index="/user/workday" class="menu-item">
          <el-icon><Clock /></el-icon>
          <template #title>工作量</template>
        </el-menu-item>
        <el-menu-item index="/user/payment" class="menu-item">
          <el-icon><Money /></el-icon>
          <template #title>工资款</template>
        </el-menu-item>
      </template>
    </el-menu>

    <!-- 底部版本号 -->
    <div class="sidebar-footer">
      <span>v6.0.0</span>
    </div>
  </div>
</template>

<script>
import { 
  HomeFilled, 
  Monitor, 
  Suitcase, 
  OfficeBuilding, 
  User, 
  Link, 
  Setting, 
  InfoFilled,
  Clock,
  Money,
  ArrowLeftBold,
  Postcard,
  Bell,
  Download,
  House,
  ChatLineRound,
  DocumentChecked,
  Service,
  FirstAidKit,
  Collection
} from '@element-plus/icons-vue'

export default {
  name: "SideBar",
  components: { 
    HomeFilled, 
    Monitor, 
    Suitcase, 
    OfficeBuilding, 
    User, 
    Link, 
    Setting, 
    InfoFilled,
    Clock,
    Money,
    ArrowLeftBold,
    Postcard,
    Bell,
    Download,
    House,
    ChatLineRound,
    DocumentChecked,
    Service,
    FirstAidKit,
    Collection
  },
  data() {
    return {
      activeMenu: this.$route.path
    };
  },
  computed: {
    isAdmin() {
      const user = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo') || '{}');
      return user && user.userType === 'admin';
    },
    isWebsiteContext() {
      return this.$route.path.startsWith('/admin/website');
    },
    isMiniProgramContext() {
      const path = this.$route.path;
      return path === '/admin/home' || path === '/admin/company' || path === '/admin/worker' || path === '/admin/account';
    }
  },
  watch: {
    '$route'(to) { this.activeMenu = to.path; }
  }
}
</script>

<style scoped>
.sidebar-wrapper {
  width: 180px;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #f1f5f9;
}

/* 工作台按钮 */
.workbench-trigger {
  padding: 12px 10px;
  cursor: pointer;
}

.trigger-box {
  background: #f1f5f9;
  height: 38px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  gap: 8px;
  color: #64748b;
  transition: all 0.3s;
}

.back-mode {
  background: #eff6ff !important;
  color: #3b82f6 !important;
}

.back-mode:hover {
  background: #dbeafe !important;
}

.trigger-box .el-icon {
  font-size: 16px;
}

.trigger-box .text {
  font-size: 12px;
  font-weight: 700;
}

.workbench-trigger:hover .trigger-box {
  background: #e2e8f0;
  color: #1e293b;
}

.workbench-trigger.is-active .trigger-box {
  background: #10b981;
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
}

/* 最终优化的石墨灰模块标签 */
.module-context-tag {
  padding-left: 44px; /* 纵向对齐上方按钮文字 */
  margin-top: -4px;
  margin-bottom: 12px;
  font-size: 11px;
  font-weight: 800;
  color: #475569; /* 中性石墨灰，增加层次感 */
  opacity: 0.8;
  letter-spacing: 1.5px;
  user-select: none;
  animation: fadeInTag 0.6s ease-out;
}

@keyframes fadeInTag {
  from { opacity: 0; transform: translateX(-5px); }
  to { opacity: 0.7; transform: translateX(0); }
}

.menu-group-title {
  font-size: 10px;
  color: #94a3b8;
  padding: 8px 20px 4px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* 菜单样式 */
.custom-menu {
  border-right: none;
  flex: 1;
}

.menu-item {
  height: 40px;
  line-height: 40px;
  margin: 2px 10px;
  border-radius: 6px;
  color: #64748b !important;
  transition: all 0.2s;
  padding: 0 10px !important;
}

.menu-item:hover {
  background-color: #f8fafc !important;
  color: #1e293b !important;
}

.menu-item.is-active {
  background-color: #10b981 !important;
  color: #ffffff !important;
  font-weight: 800;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);
  position: relative;
}

.menu-icon {
  margin-right: 10px;
  font-size: 20px;
}

.sidebar-footer {
  padding: 16px;
  text-align: center;
  font-size: 10px;
  color: #cbd5e1;
  border-top: 1px solid #f8fafc;
}

:deep(.el-menu-item [class^="el-icon"]) {
  margin-right: 0;
}
</style>
